import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { AppSettings } from '../Configuration/types';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { store } from '@reduxStore';
import { getMsalInstance } from '../Security/msalInstance';

/**
 * Method used for instantiating the AppInsights client used by the Application. Maintained outside of the component tree.
 */
export function createAppInsightsInstance(appSettings: AppSettings, reactPlugin: ReactPlugin) {
	if (appSettings.azure.appInsightsConnectionString) {
		const appInsights = new ApplicationInsights({
			config: {
				connectionString: appSettings.azure.appInsightsConnectionString,
				enableAutoRouteTracking: true,
				extensions: [reactPlugin]
			}
		});

		appInsights.loadAppInsights();

		appInsights.context.application.ver = NPM_PACKAGE_VERSION;

		appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
			const instance = getMsalInstance();
			const activeAccount = instance.getActiveAccount();
			envelope.tags = envelope.tags || [];

			let authenticatedUser = undefined;
			if (activeAccount && activeAccount.idTokenClaims) {
				authenticatedUser = String(activeAccount.idTokenClaims['samAccountName']);
			}

			const terminalNumber = store.getState().applicationState.selectedTerminal?.number;

			// The Tags type in the ms library is a generic object of [key: string]: any meaning push() is not defined
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			envelope.tags.push({
				'ai.cloud.role': 'BessemerMgmt.TriniumWeb.Dispatch'
			});
			envelope.data = {
				...envelope.data,
				company: appSettings.company,
				terminalNumber: terminalNumber,
				samAccountName: authenticatedUser
			};
		});

		return appInsights;
	}

	return undefined;
}
